"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurStory() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative w-full min-h-screen overflow-hidden bg-background">
      {}
      <div className="fixed inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/blueprint_pipelines_illustration.png)] bg-cover bg-center opacity-10 pointer-events-none" aria-hidden="true" />

      {}
      <div className="relative z-10 container mx-auto px-6 py-32 md:py-40 lg:py-48 flex items-center justify-center min-h-screen">
        <div className="max-w-4xl mx-auto">
          {}
          <div className="bg-background/80 backdrop-blur-md border border-border rounded-lg shadow-medium p-8 md:p-12 lg:p-16 hover:shadow-strong transition-all duration-[var(--duration-medium)] hover:scale-[1.01]">
            <div className="text-center">
              {}
              <h1 ref={headlineRef} className={`font-display text-4xl md:text-5xl lg:text-6xl font-bold bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent mb-8 tracking-tight transition-all duration-[350ms] ease-[cubic-bezier(0.4,0,0.2,1)] motion-reduce:transition-none ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} hover:-translate-y-0.5 motion-reduce:hover:translate-y-0`}>
                Our Story
              </h1>

              {}
              <p ref={paragraphRef} className={`font-sans text-lg md:text-xl lg:text-2xl text-muted leading-[1.7] tracking-wide transition-all duration-[350ms] delay-100 ease-[cubic-bezier(0.4,0,0.2,1)] motion-reduce:transition-none ${paragraphVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} hover:-translate-y-0.5 motion-reduce:hover:translate-y-0`}>
                For 20 years, AA Eagle Plumbing has specialized in delivering fast, reliable, and high-quality water pump services to our valued customers. Our expert technicians handle all types of water pump systems with precision and care, from installation and maintenance to repairs and replacements. We proudly serve both commercial and residential clients, ensuring dependable water pump solutions for every project. Our commitment to timely workmanship and free shop estimates makes us the trusted choice for all your water pump service needs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}